import { atom } from 'jotai'

export const alertAtom = atom(false)
